// components/ApplicationSubmitted.jsx
import { Box, VStack, Heading, Text, Button, Icon } from "@chakra-ui/react";
import { CheckCircleIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { OnboardingLayout } from "../layout/OnboardingLayout";
import DynamicPageTitle from "./PageTitle ";
import Cookies from "js-cookie";

const ApplicationSubmitted = () => {
    const navigate = useNavigate();

    const handleReturnHome = () => {
        sessionStorage.clear();
        localStorage.clear();
        Cookies.remove("userData");
        Cookies.remove("uid");
        Cookies.remove("isLoggedin");
        Cookies.remove("userLevel");
        Cookies.remove("token");
        navigate("/");
    };

    return (
        <>
            <DynamicPageTitle pageTitle={"Personal Info"} />

            <OnboardingLayout
                pageTitle={null}
                mainContent={<Box


                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    p={4}
                >
                    <VStack
                        spacing={6}
                        textAlign="center"
                        maxW="500px"
                        bg="white"
                        p={8}
                        borderRadius="lg"
                        boxShadow="md"
                    >
                        <Icon as={CheckCircleIcon} boxSize={12} color="green.500" />

                        <Heading size="lg" color="green.600">
                            Application Submitted!
                        </Heading>

                        <Text color="gray.600" lineHeight="tall">
                            Your application has been received and is now under review.
                            Our team will contact you once your application has been processed.
                        </Text>

                        <Text fontSize="sm" color="red.500" fontStyle="italic" fontWeight={'bold'}>
                            You'll have to logout and re-login to be automatically redirected to the next stage when your application is approved.
                        </Text>

                        <Button
                            colorScheme="blue"
                            rightIcon={<ArrowForwardIcon />}
                            onClick={handleReturnHome}
                        >
                           Logout 
                        </Button>
                    </VStack>
                </Box>}
            /></>
    )
}




export default ApplicationSubmitted;